import { makeStyles } from '@material-ui/core';
import React from 'react';
import VertStep from './VertStep';

export default function VertStepper(props) {

    const classes = useStyles();
    let steps = []
    if (props.steps) {
        steps = props.steps.map((p) => (<VertStep {...props} key={p.id} {...p}></VertStep>));
    }
    return (
        <div className={classes.container}>
            {steps}
        </div>
    )

}


const useStyles = makeStyles({
    container: {
        margin: 25,
    }
});